import { RequestHistory } from '@/interfaces/my-profile/request-history';
import { Person } from '@/interfaces/person/index';
import { Details } from '@/interfaces/requirement/index';
import { RequestHistoryService } from '@/services/request-history/request-history.service';
import { StoreState } from '@/store';
import { State } from '@/store/login/reducer';
import { getCurrentUserData } from '@/store/login/selectors';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { OrderPipe } from 'ngx-order-pipe';

@Component({
  selector: 'app-table-recent-request',
  templateUrl: './table-recent-request.component.html',
  styleUrls: ['./table-recent-request.component.css'],
})
export class TableRecentRequestComponent implements OnInit {

  userData: Partial<State> = {};
  panelOpenState = false;
  infoActivity: boolean = false;

  imagesStatus: Record<string, string> = {
    PENDIENTE: 'assets/img/atencion.png',
    EN_PROCESO: 'assets/img/espera.png',
    EN_CURSO: 'assets/img/espera.png',
    SOLICITUD_ANTECEDENTES: 'assets/img/espera.png',
    RECHAZADA: 'assets/img/rechazado.png',
    APROBADA: 'assets/img/aprobado.png',
    ELIMINADO: 'assets/img/rechazado.png',
    CANCELADA: 'assets/img/rechazado.png',
  };

  allHistoryRequest: Partial<RequestHistory[]> = []

  public config: any = {
    id: 'custom',
    itemsPerPage: 5,
    currentPage: 1,
    totalItems: this.allHistoryRequest.length,
  };

  modalState: boolean = true;

  sortedCollection: Partial<RequestHistory[]>;
  personData: Partial<Person> = {};
  detailData: Partial<Details> = {};
  id: number = 0;

  detailRequestShow: boolean = false;

  showingDetailRequirementId: number = 0;
  getRequestError: string = 'DEFAULT';
  requestLoading: boolean = true;
  constructor(
    private historyRequestService: RequestHistoryService,
    private store: Store<StoreState>,
    private router: Router,
    private orderPipe: OrderPipe,
  ) {
    const storeLoginSlice$ = getCurrentUserData(this.store);
    storeLoginSlice$.subscribe({
      next: (userData) => {
        this.userData = userData;

      },
    });
    this.allHistoryRequest = this.allHistoryRequest.slice();
    this.sortedCollection = this.orderPipe.transform(this.allHistoryRequest, 'allHistoryRequest.requestType');
  }

  ngOnInit(): void {
    this.getAllRequestHistory();

  }

  formatStatus(status?: string) {
    if (status) {
      return status.toUpperCase().replace(/\s+/g, '_');
    }
    return '';
  }

  getAllRequestHistory() {
    const userId = this.userData.mdmid;
    if (userId) {
      const requestData = this.historyRequestService.getAllHistory(userId);
      requestData.subscribe({
        next: (response) => {
          this.allHistoryRequest = response.sort((a, b) => {
            if (a.requirementDate > b.requirementDate) {
              return -1;
            }
            if (a.requirementDate < b.requirementDate) {
              return 1;
            }
            return 0;
          }).slice(0, 5);
          this.requestLoading = false;
        },
        error: () => {
          this.allHistoryRequest = [];
          this.getRequestError = 'Ha ocurrido un error al intentar obtener la información asociada a solicitudes recientes.';
          this.requestLoading = false;
        },
      });
    }
  }

  /// //////////////sorting ////////////

  order: string = ''
  // 1 -> disabled ; 2 -> asc ; 3 -> desc
  orderStatus: 1 | 2 | 3 = 1;
  reverse: boolean = false;

  setOrder(headerName: string) {
    if (this.order !== headerName) {
      this.orderStatus = 2;
      this.order = headerName;
    }
    else if (this.orderStatus < 3) {
      this.orderStatus++;
    }
    else {
      this.orderStatus = 1;
      this.order = '';
    }

    if (this.orderStatus === 3) {
      this.reverse = true;
    }
    else {
      this.reverse = false;
    }
  }
  getSortingStatusImage(orderStatus: 1 | 2 | 3, arrow: 'UP' | 'DOWN') {
    if (arrow === 'UP') {
      if (orderStatus === 2) {
        return 'assets/img/arrow_r_g.png';
      }
      return 'assets/img/arrow_b_g.png';
    }

    if (orderStatus === 3) {
      return 'assets/img/arrow_r_g.png';
    }
    return 'assets/img/arrow_b_g.png';
  }

  onShowDetail(requirementId: number | undefined) {
    if (requirementId) {
      this.showingDetailRequirementId = requirementId;
    }
  }

  onHideDetail() {
    this.showingDetailRequirementId = 0;
  }

}
